export class Controller {

    /** @ngInject */
    constructor($q, Alert) {
        this.$q = $q;
        this.Alert = Alert;
    }

    $onInit() {
        if (this.imageMaxSize == null) {
            this.imageMaxSize = 1000000;
        }
    }

    cancel() {
        this.isEditing = false;
    }

    edit() {
        this.imageFile = null;
        this.isEditing = true;
    }

    save() {
        this.isSaving = true;
        this.$q
            .resolve(this.onSave({$value: this.imageFile}))
            .finally(() => this.isEditing = this.isSaving = false)
    }

    reset() {
        this.isSaving = true;
        this.$q
            .resolve(this.onReset())
            .finally(() => this.isEditing = this.isSaving = false)
    }


    fileNameChanged(){
        if (this.imageFile.size > this.imageMaxSize) {
            this.Alert('danger', 'Photo should be smaller than ' + this.imageMaxSize/1000000 + 'MB');
            this.imageFile = null;
        }
    }

    notModified() {
        return this.imageFile == null;
    }
}



// WEBPACK FOOTER //
// ./src/portal/components/sp-editable-image/sp-editable-image.controller.js